import produce from "immer";
import { initialState } from "./initialState";
import * as types from "./types";

const userReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case types.LOAD_TAXPAYER:
        draft.taxPayer = action.taxPayer;
        break;
      case types.LOAD_CONTRIBUTOR:
        draft.contributor = action.contributor;
        break;
      case types.SET_DUPLICATE_DATA:
        draft.duplicateData = !draft.duplicateData;
        break;
    }
  });

export default userReducer;
